module.exports = __webpack_public_path__ + "static/ramsauer-carreisen-5264b68f412846299e65b7f72b0870a7.svg";